import type { ProgramSelectorViewType } from '../../types/index.ts';
import type { Density } from '../../themeTokens.ts';
import useStore from '../index.ts';
import { initialThemeEditorState } from './store.ts';

export const setGuideDurationState = (duration: number) => {
  useStore.setState((state) => {
    state.theme.guideDuration = duration;
  });
};

export const setThemePreference = (pref: 'light' | 'dark' | 'system') =>
  useStore.setState((state) => {
    state.theme.themePreference = pref;
  });

export const setDensity = (density: Density) =>
  useStore.setState((state) => {
    state.theme.density = density;
  });

export const setProgrammingSelectorViewState = (
  view: ProgramSelectorViewType,
) => {
  useStore.setState((state) => {
    state.theme.programmingSelectorView = view;
  });
};

export const resetThemeEditorState = () => {
  useStore.setState((state) => {
    const newState = {
      ...state,
      ...initialThemeEditorState,
    };

    return newState;
  });
};
